module.exports = {
  __depends__: [
    require(162),
    require(203)
  ],
  __init__: [ 'autoScroll' ],
  autoScroll: [ 'type', require(138) ]
};